const MAP = {
  // leads
  New: "bg-blue-50 text-blue-700 border border-blue-200",
  Contacted: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  "Consultation Booked": "bg-violet-50 text-violet-700 border border-violet-200",
  "Consultation Completed": "bg-teal-50 text-teal-700 border border-teal-200",
  "Follow-up": "bg-amber-50 text-amber-700 border border-amber-200",
  "Proposal Sent": "bg-cyan-50 text-cyan-700 border border-cyan-200",
  Won: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Lost: "bg-rose-50 text-rose-700 border border-rose-200",
  "Not Interested": "bg-slate-100 text-slate-500",
  // documents
  "Not Requested": "bg-slate-100 text-slate-600",
  Requested: "bg-amber-50 text-amber-700 border border-amber-200",
  Uploaded: "bg-sky-50 text-sky-700 border border-sky-200",
  "Under Review": "bg-violet-50 text-violet-700 border border-violet-200",
  Accepted: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Rejected: "bg-rose-50 text-rose-700 border border-rose-200",
  "Replacement Required": "bg-orange-50 text-orange-700 border border-orange-200",
  Expired: "bg-slate-200 text-slate-700",
  // applications / generic
  Active: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Processing: "bg-sky-50 text-sky-700 border border-sky-200",
  Completed: "bg-emerald-600 text-white",
  Draft: "bg-slate-100 text-slate-600",
  Sent: "bg-sky-50 text-sky-700 border border-sky-200",
  "Partially Paid": "bg-amber-50 text-amber-700 border border-amber-200",
  Paid: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Overdue: "bg-rose-50 text-rose-700 border border-rose-200",
  Cancelled: "bg-slate-100 text-slate-500 line-through",
  Inactive: "bg-amber-50 text-amber-700 border border-amber-200",
  "On Hold": "bg-slate-100 text-slate-700 border border-slate-300",
  Blocked: "bg-rose-50 text-rose-700 border border-rose-300",
  // client pipeline
  "Documents Pending": "bg-amber-50 text-amber-700 border border-amber-200",
  Submitted: "bg-sky-50 text-sky-700 border border-sky-200",
  Decision: "bg-violet-50 text-violet-700 border border-violet-200",
  Approved: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Refused: "bg-rose-50 text-rose-700 border border-rose-200",
  Closed: "bg-slate-200 text-slate-600",
  Disabled: "bg-slate-100 text-slate-500 line-through",
  // appointments
  Requested_appt: "bg-amber-50 text-amber-700",
  Confirmed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  // tasks
  "To Do": "bg-slate-100 text-slate-600",
  "In Progress": "bg-sky-50 text-sky-700 border border-sky-200",
  "Waiting for Client": "bg-amber-50 text-amber-700 border border-amber-200",
  // priority
  High: "bg-rose-50 text-rose-700 border border-rose-200",
  Urgent: "bg-rose-600 text-white",
  Normal: "bg-slate-100 text-slate-600",
  Low: "bg-slate-100 text-slate-500",
};

export function StatusBadge({ status, className = "" }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-600";
  return (
    <span
      data-testid={`status-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${cls} ${className}`}
    >
      {status}
    </span>
  );
}
